module.exports = __webpack_public_path__ + "static/media/d6_logof588450ac4e4bf02287fd2e47374a0f7.webp";